module.exports = __webpack_public_path__ + "img/azad_kashmir.0f5fd77.webp";